<template>
    <div class="w-full ">
        <div
            class="w-full relative group"
            v-if="state.isPdfAvailable !== false"
        >
            <pdf-canvas
                :baseString="state.pdfInBaseFormat"
                v-if="state.pdfInBaseFormat"
                ref="pdfCanvas"
            />
        </div>

        <div
            v-if="state.isPdfAvailable === false"
            class="mb-20"
            style="padding:0 5vw;"
        >
            <div
                class="w-full max-w-4xl flex flex-col items-start justify-start "
            >
                <div
                    class="text-black text-lg w-full whitespace-pre-wrap font-semibold mt-10"
                >
                    Fehler bei der Pdf Wiedergabe
                </div>
                <p
                    class="text-base text-black max-w-4xl whitespace-pre-line  mt-8"
                >
                    Bei der Wiedergabe der PDF ist ein Fehler aufgetreten.<br />Bitte
                    melden Sie sich bei dem WAY Team, damit Sie diesen Fehler
                    beheben können.<br /><br />Überspringen Sie vorläufig diese
                    PDF<br />
                    und schauen Sie es sich zu einem späteren Zeitpunkt an.
                </p>
                <custom-button
                    @click="UPDATE_SLIDE_PROGRESS(true)"
                    class="w-72 h-11 mt-10"
                    :text="'PDF überspringen'"
                    :bgColor="'bg-primary'"
                    :textColor="'text-white'"
                    :id="'skip-pdf-button'"
                />
            </div>
        </div>
        <div
            class="flex flex-col justify-start items-center px-4 py-8 bg-white"
            v-if="state.pdfInBaseFormat && state.isPdfAvailable !== false"
        >
            <notes
                @changeTime="
                    (page) => {
                        pdfCanvas.pdfState.pageNumber = page;
                        pdfCanvas.changePage();
                        scrollToTop();
                    }
                "
                :watchTime="pdfCanvas ? pdfCanvas.pdfState.pageNumber : 1"
                :isPdf="true"
            />
        </div>
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
    ref,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import {
    MEDIA_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../../../../store/types";
import { cloneData, getData } from "../../../../../common/dataHelper";
import CustomButton from "../../../../../components/input/CustomButton.vue";
import { SentryService } from "../../../../../common/sentryService";
import PdfCanvas from "./PdfCanvas.vue";
import Notes from "../Notes.vue";
export default defineComponent({
    name: "PdfViewer",
    components: { CustomButton, PdfCanvas, Notes },

    setup() {
        const store = useStore();
        const pdfCanvas = ref();
        /**
         *   State
         */
        const state = reactive({
            slide: null,
            pdfInBaseFormat: null,
            isPdfAvailable: null, //if null loading if false not available
        });
        /**
         *  Functions
         */

        async function FETCH_MEDIA_AS_BASE() {
            const response = await store.dispatch(
                `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.FETCH_MEDIA_AS_BASE}`,
                {
                    media: { id: state.slide.media_id },
                }
            );
            if (getData(response, "status") != 200) {
                state.isPdfAvailable = false;
                SentryService.sendError({
                    message: "PDF ist für den Nutzer nicht verfügbar.",
                    jsonObject: response,
                });
            } else {
                state.pdfInBaseFormat = response.data;
                state.isPdfAvailable = true;
            }
        }
        function scrollToTop() {
            const scrollBox = document.getElementById("course-main");
            if (scrollBox) {
                scrollBox.scrollTop = 0;
            }
        }
        /**
         *  Computed
         */
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );

        /**
         *  Created
         */
        onMounted(() => {
            state.slide = cloneData(GET_SLIDE.value);
            FETCH_MEDIA_AS_BASE();
        });

        return {
            state,
            GET_SLIDE,
            scrollToTop,
            pdfCanvas,
        };
    },
});
</script>
